import { Link } from "react-router-dom";
import { MapPin } from "@phosphor-icons/react";
import { DUMP_GUIDE_LINKS } from "@/seoContentV3";

export default function DumpGuideLinks({ place }) {
  return (
    <section className="px-5 lg:px-8 py-14 bg-[#F4FAF0]" data-testid="dump-guide-links">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-display font-black tracking-tighter text-2xl lg:text-3xl text-[#15306E]">Hauling it yourself from {place}? San Diego dump guides</h2>
        <p className="text-[#52525B] mt-2 mb-6">Fees, hours and what each facility accepts. Or skip the trip: we pick up the same day.</p>
        <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {DUMP_GUIDE_LINKS.map((g) => (
            <li key={g.to}>
              <Link to={g.to} data-testid={`dump-guide-link-${g.to.split("/").pop()}`}
                className="flex items-center gap-2 bg-white border border-[#E4E4E7] hover:border-[#46A01E] rounded-sm px-4 py-3 font-display font-bold text-[#15306E] transition-colors">
                <MapPin size={16} weight="fill" className="text-[#46A01E]" /> {g.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
